import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  statusBadge: {
    background: "#FEE4E2 !important",
    border: "1px solid #E0E2E7",
    padding: "3px 10px",
    borderRadius: 20,
    height: 32,
    fontWeight: 600,
    fontSize: 10,
    lineHeight: "20px",
    color: "#F97066 !important",
  },
  statusBadgeActive: {
    background: "#D1FADF !important",
    border: "1px solid #D1FADF",
    color: "#32D583 !important",
  },
  button: {
    cursor: "pointer",
  },
  changeStatusButton: {
    whiteSpace: "nowrap",
    "& span > div": {
      display: "flex",
      alignItems: "center",
    },
  },
  createContainer: {
    marginTop: "52px",
    "& .MuiListItem-button:hover": {
      backgroundColor: "#EDF5FB",
      color: "#308CDB",
      fontWeight: 600,
    },
  },
  createButtonActive: {
    backgroundColor: "#31B6AC",
  },
  createItem: {
    color: "#667085",
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: "Manrope",
    minWidth: "148px",
    height: "40px",
  },
}));

export default styles;
